import type { ScheduledDelivery } from "../../api/types";
import { deliveryResult, deliveryVatTotals } from "../../utils/deliveryOverview";

const euros = (value: string) => new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(Number(value));

export function DeliveryResult({ delivery }: { delivery: ScheduledDelivery }) {
  const result = deliveryResult(delivery);
  const detail = result.detail.split(" · ").filter((part) => !/^\d+ differences?$/.test(part)).join(" · ");
  return <div>
    <span className={`badge ${result.tone}`} style={{ textTransform: "none", letterSpacing: 0, whiteSpace: "nowrap" }}>{result.label}</span>
    {detail && <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>{detail}</div>}
  </div>;
}

export function DeliveryVatTotal({ delivery }: { delivery: ScheduledDelivery }) {
  const totals = deliveryVatTotals(delivery);
  return <div style={{ textAlign: "right", whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}>
    <div style={{ fontWeight: 600 }}>{totals.gross !== null ? `${euros(totals.gross)} incl. VAT` : "VAT total unavailable"}</div>
    <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>{totals.net !== null ? `${euros(totals.net)} excl. VAT` : "Pre-VAT total unavailable"}</div>
    {totals.expected && <div className="muted" style={{ fontSize: 12 }}>Expected</div>}
  </div>;
}
